__turbopack_context__.v({
  "aiBadge": "AnalysisRecommendationCard-module__cGbRDa__aiBadge",
  "arrow": "AnalysisRecommendationCard-module__cGbRDa__arrow",
  "badge": "AnalysisRecommendationCard-module__cGbRDa__badge",
  "item": "AnalysisRecommendationCard-module__cGbRDa__item",
  "itemBadges": "AnalysisRecommendationCard-module__cGbRDa__itemBadges",
  "itemStart": "AnalysisRecommendationCard-module__cGbRDa__itemStart",
  "title": "AnalysisRecommendationCard-module__cGbRDa__title",
});
